// status: updated
import { Icons } from "@assets/assets";
import { StaticImageData } from "next/image";

export interface TechnologyItem {
  name: string;
  icon: StaticImageData | string;
  link: string;
}

export interface CategoryData {
  key: string;
  label: string;
  technologies: TechnologyItem[];
}

export const TECH_CATEGORIES: CategoryData[] = [
  {
    key: "backend",
    label: "Backend",
    technologies: [
      { name: "nodejs", icon: Icons?.NodeJS, link: "/nodejs-development" },
      { name: ".net", icon: Icons?.DotNet, link: "/asp-dotnet-development" },
      { name: "php", icon: Icons?.PHP, link: "/php-development" },
      {
        name: "Python",
        icon: Icons?.Python,
        link: `${process.env.NEXT_PUBLIC_BASE_URL}/python-development-company`,

      },
      {
        name: "Laravel",
        icon: Icons?.technologyIcon?.Laravel,
        link: "/laravel-web-development",
      },
      {
        name: "CodeIgniter",
        icon: Icons?.technologyIcon?.codeigniter,
        link: "/codeigniter-development",
      },
      {
        name: "CakePHP",
        icon: Icons?.technologyIcon?.Cakephp,
        link: "/cakephp-development",
      },
      {
        name: "Django",
        icon: Icons?.technologyIcon?.Django,
        link: "/django-development-company",
      },
      {
        name: "Express.js",
        icon: Icons?.technologyIcon?.expressJs,
        link: "",
      },
      {
        name: "NestJS",
        icon: Icons?.technologyIcon?.Nestjs,
        link: "",
      },
    ],
  },

  // -------------------------
  // Frontend
  // -------------------------
  {
    key: "frontend",
    label: "Frontend",
    technologies: [
      {
        name: "Angular",
        icon: Icons?.technologyIcon?.Angular,
        link: "/angular-development",
      },
      {
        name: "ThreeJS",
        icon: Icons?.technologyIcon?.Threejs,
        link: "/threejs-development-company",
      }, // not previously in list
      {
        name: "VueJS",
        icon: Icons?.technologyIcon?.VueJS,
        link: "/vuejs-development-company",
      },
      {
        name: "ReactJS",
        icon: Icons?.technologyIcon?.React,
        link: "/reactjs-development",
      },
      {
        name: "Next.js",
        icon: Icons?.technologyIcon?.nextJs,
        link: "",
      },
      {
        name: "Nuxt.js",
        icon: Icons?.nuxtJs,
        link: "",
      },
    ],
  },

  // -------------------------
  // Mobile
  // -------------------------
  {
    key: "mobile",
    label: "Mobile",
    technologies: [
      {
        name: "React Native",
        icon: Icons?.technologyIcon?.React,
        link: "/react-native-app-development",
      },
      {
        name: "Flutter",
        icon: Icons?.technologyIcon?.flutter,
        link: "/flutter-app-development",
      },
      {
        name: "Ionic",
        icon: Icons?.technologyIcon?.Ionic,
        link: "/ionic-app-development",
      },
      {
        name: "Java",
        icon: Icons?.technologyIcon?.JAVA,
        link: "/java-application-development",
      },
      {
        name: "Swift",
        icon: Icons?.technologyIcon?.Swift,
        link: "/swift-app-development",
      },
      {
        name: "Kotlin",
        icon: Icons?.technologyIcon?.kotlinIcon,
        link: "/kotlin-app-development",
      },
      {
        name: "Jetpack Compose",
        icon: Icons?.technologyIcon?.jetpackCompose,
        link: "",
      },
      {
        name: "SwiftUI",
        icon: Icons?.technologyIcon?.swiftUi,
        link: "",
      },
    ],
  },

  // -------------------------
  // Ecommerce
  // -------------------------
  {
    key: "Ecommerce",
    label: "Ecommerce",
    technologies: [
      {
        name: "Magento",
        icon: Icons?.technologyIcon?.Magento,
        link: "/magento-development",
      },
      {
        name: "WooCommerce",
        icon: Icons?.technologyIcon?.WooCommerce,
        link: "/woocommerce-development",
      },
      {
        name: "Shopify",
        icon: Icons?.technologyIcon?.Shopify,
        link: "/shopify-development",
      },
      {
        name: "BigCommerce",
        icon: Icons?.technologyIcon?.bigCommerce,
        link: "",
      },
    ],
  },

  // -------------------------
  // CMS
  // -------------------------
  {
    key: "CMS",
    label: "CMS",
    technologies: [
      {
        name: "WordPress",
        icon: Icons?.technologyIcon?.WordPress,
        link: "/wordpress-development",
      },
      {
        name: "Joomla",
        icon: Icons?.technologyIcon?.Joomla,
        link: "/joomla-development",
      },
      {
        name: "Contentful",
        icon: Icons?.technologyIcon?.contentful,
        link: "",
      },
    ],
  },

  // -------------------------
  // Database
  // -------------------------
  {
    key: "database",
    label: "Database",
    technologies: [
      { name: "Mongodb", icon: Icons?.technologyIcon?.MongoDB, link: "" },
      { name: "MySQL", icon: Icons?.technologyIcon?.MySql, link: "" },
      { name: "PostgreSQL", icon: Icons?.technologyIcon?.PostgreSql, link: "" },
      { name: "Redis", icon: Icons?.technologyIcon?.Redis, link: "" },
      { name: "SQLite", icon: Icons?.technologyIcon?.SQLite, link: "" },
      {
        name: "Microsoft SQL Server",
        icon: Icons?.technologyIcon?.microsoftsqlserver,
        link: "",
      },
      {
        name: "Firestore",
        icon: Icons?.technologyIcon?.fireStore,
        link: "",
      },
      {
        name: "DynamoDB",
        icon: Icons?.technologyIcon?.dynamoDb,
        link: "",
      },
    ],
  },
];
